import { useIsFavourite, useToggleFavourite } from '@platewell/query';
import type { RecipeId } from '@platewell/core';

export function FavouriteButton({
  recipeId,
  className = 'favourite-button',
  size = 22,
}: {
  recipeId: RecipeId;
  className?: string;
  size?: number;
}) {
  const isFavourited = useIsFavourite(recipeId);
  const toggle = useToggleFavourite();

  return (
    <button
      type="button"
      className={className}
      aria-label={isFavourited ? 'Remove from favourites' : 'Add to favourites'}
      aria-pressed={isFavourited}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggle(recipeId);
      }}
    >
      <StarIcon filled={isFavourited} size={size} />
    </button>
  );
}

export function StarIcon({ filled, size }: { filled: boolean; size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={filled ? 0 : 1.5}
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Filled star for recipe cards; read-only indicator. */
export function FavouriteBadge({
  className = 'card-favourite',
  size = 22,
}: {
  className?: string;
  size?: number;
}) {
  return (
    <span className={className} aria-label="Favourited">
      <StarIcon filled size={size} />
    </span>
  );
}
